import { useCallback, useRef } from '@max/max';
/**
 * 防抖 Hook
 * @param fn 需要防抖的函数
 * @param delay 防抖延迟时间（毫秒）
 * @returns 防抖处理后的函数
 */
export function useDebounce(fn, delay = 300) {
    const timerRef = useRef(null);
    return useCallback((...args) => {
        if (timerRef.current) {
            clearTimeout(timerRef.current);
        }
        timerRef.current = setTimeout(() => {
            fn(...args);
            timerRef.current = null;
        }, delay);
    }, [fn, delay]);
}
